export interface Page<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
}

/**
 * Backend uses {items, page, size, total, totalPages}; legacy code expects Spring's
 * {content, number, size, totalElements, totalPages, first, last}. This adapter accepts
 * either shape and produces the canonical Page<R>. Optionally maps individual items.
 */
export function normalizePage<T, R = T>(
  raw: unknown,
  mapItem?: (item: T) => R,
): Page<R> {
  const r = (raw ?? {}) as Record<string, unknown>;
  const rawItems = (r.items ?? r.content ?? []) as T[];
  const number = (r.page ?? r.number ?? 0) as number;
  const size = (r.size ?? rawItems.length) as number;
  const totalElements = (r.total ?? r.totalElements ?? rawItems.length) as number;
  const totalPages = (r.totalPages ?? Math.max(1, Math.ceil(totalElements / Math.max(1, size)))) as number;
  const content = (mapItem ? rawItems.map(mapItem) : (rawItems as unknown as R[])) as R[];
  return {
    content,
    totalElements,
    totalPages,
    number,
    size,
    first: number === 0,
    last: number + 1 >= totalPages,
  };
}

export interface PageRequest {
  page?: number;
  size?: number;
  sort?: string;
}

export type UUID = string;
export type Iso8601 = string;
